import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import CloseIcon from '@mui/icons-material/Close';
import { appConfig } from '../../config/appConfig';

let dismissedForClient = null;

const isDismissedFor = (clientId) =>
    clientId !== undefined && clientId !== null && dismissedForClient === clientId;

const PoliciesAwarenessBanner = ({ clientId }) => {
    const { t } = useTranslation();
    const [dismissed, setDismissed] = useState(() => isDismissedFor(clientId));

    const dismiss = () => {
        dismissedForClient = clientId;
        setDismissed(true);
    };

    if (!appConfig.policiesEnabled || dismissed) return null;

    return (
        <div className="policies-banner">
            <span className="policies-banner__icon">
                <ErrorOutlineIcon />
            </span>
            <div className="policies-banner__info">
                <p className="policies-banner__title">{t('invoices.policiesBannerTitle')}</p>
                <Link to="/dashboard/policies" className="policies-banner__message">
                    {t('invoices.policiesBannerMessage')}
                </Link>
            </div>
            <button
                type="button"
                className="policies-banner__close"
                aria-label={t('invoices.policiesBannerDismissLabel')}
                onClick={dismiss}
            >
                <CloseIcon />
            </button>
        </div>
    );
};

PoliciesAwarenessBanner.propTypes = {
    clientId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default PoliciesAwarenessBanner;
